import { render, staticRenderFns } from "./DokumenPod.vue?vue&type=template&id=9b1abab8&"
import script from "./DokumenPod.vue?vue&type=script&lang=js&"
export * from "./DokumenPod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports